module.exports = __webpack_public_path__ + "static/dt_white-cd32528e87d0aa023a5dfef5176a8705.svg";